import React from 'react';
import { getColorPropsByHex } from '@helpers/color';
import getContrastYIQ from '@helpers/color-contrast';
import { ColorWrapper, ColorName, ColorProperties, ColorProperty, ColorValue, PropertiesWrapper, StyledCopy, StyledCopyIcon } from './color.styled';
var Color = function Color(_ref) {
    var name = _ref.name, HEX = _ref.HEX;
    var textColor = getContrastYIQ(HEX);
    return /*#__PURE__*/ React.createElement(ColorWrapper, {
        HEX: HEX
    }, /*#__PURE__*/ React.createElement(ColorName, {
        textColor: textColor
    }, name), /*#__PURE__*/ React.createElement(PropertiesWrapper, null, Object.entries(getColorPropsByHex(HEX)).map(function (_ref2) {
        var key = _ref2[0], value = _ref2[1];
        return /*#__PURE__*/ React.createElement(ColorProperties, {
            key: key,
            textColor: textColor
        }, /*#__PURE__*/ React.createElement(StyledCopy, {
            textColor: textColor,
            baseColor: HEX,
            copyText: value,
            copyLabel: key + " Code",
            buttonWidth: 24,
            buttonLabel: /*#__PURE__*/ React.createElement(StyledCopyIcon, {
                width: "12",
                height: "12",
                color: textColor
            })
        }), /*#__PURE__*/ React.createElement(ColorProperty, null, key), /*#__PURE__*/ React.createElement(ColorValue, null, value));
    })));
};
export default Color;
